import React from 'react';

export const LeftArrowSVG = ({ style }: any) => (
  <svg
    width="16"
    height="16"
    style={{ marginLeft: 6, color: 'white', ...style }}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.7241 8.66672L7.52882 12.862L8.47163 13.8048L14.2764 8.00005L8.47163 2.19531L7.52882 3.13812L11.7241 7.33338H2.00023V8.66672H11.7241Z"
      fill="currentColor"
    />
  </svg>
);
